import MDinput from '@/components/MDinput';
import { validatorEmail, validatorRequire, validatorRequireMultipleSelect } from '@/utils/validators';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    id: {
      type: null,
      defaultValue: undefined
    },
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        required: true,
        caption: 'login.code'
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    email: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true,
        caption: 'common.email'
      },
      rules: [
        {
          validator: validatorRequire
        },
        {
          validator: validatorEmail
        }
      ]
    },
    avatar: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        caption: 'user.avatar'
      }
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255
      }
    },
    roles: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'user.roles',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['role/isLoading'],
        options: vue.$store.getters['role/loadedItems'],
        required: true
      },
      rules: [
        {
          validator: validatorRequireMultipleSelect
        }
      ]
    },
    companies: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'user.workingAt',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['company/isLoading'],
        options: vue.$store.getters['company/loadedItems']
      }
    },
    domainIds: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'common.domains',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['domain/isLoading'],
        options: vue.$store.getters['domain/loadedItems']
      }
    },
    workshopIds: {
      type: Select,
      defaultValue: [],
      props: {
        caption: 'common.workshops',
        valueField: 'id',
        labelField: 'name',
        multiple: true,
        loading: vue.$store.getters['workshop/isLoading'],
        options: vue.$store.getters['workshop/loadedItems']
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  const user = {
    ...form,
    roles: [],
    companies: []
  };
  if (form.id) {
    user['id'] = form.id;
  }
  form.roles.forEach(roleID => {
    const role = vue.$store.getters['role/getLoadedItemByID'](roleID);
    user.roles.push(role);
  });
  form.companies.forEach(companyID => {
    const company = vue.$store.getters['company/getLoadedItemByID'](companyID);
    user.companies.push(company);
  });
  return user;
}

export function createFormDataFromItem(vue, user) {
  const form = {
    ...user
  };
  form.roles = [];
  user.roles.forEach(role => {
    form.roles.push(role.id);
  });
  form.companies = [];
  user.companies.forEach(company => {
    form.companies.push(company.id);
  });
  return form;
}
